<div class="container">
  @if (showFilters) {
    <h1 class="p-2">Reporting</h1>
  }
  @if (showFilters) {
    <div class="mx-5 mt-4">
      @if (showAuditFilter) {
        <div class=" mb-2 border-grey-500 border-[1px] rounded-md p-3">
          <p class="text-lg hover:cursor-pointer" (click)="auditFilterSwitch()">{{ 'audit' | customerTerm:true }}</p>
          @if (!collapseAuditFilter) {
            <div>
              <div class="flex-col flex lg:flex-row justify-between">
                <select class="text-box w-full md:max-w-xl mt-2 mx-2 standardTextSize"
                  [(ngModel)]="SelectedAuditType" (change)="updateAudits()">
                  @for (at of AuditTypes; track at) {
                    <option [ngValue]="at">{{at.Description}}</option>
                  }
                </select>
                <select class="text-box w-full md:max-w-xl mx-2 lg:mx-0 mt-2 standardTextSize"
                  [(ngModel)]="SelectedFrequency" (change)="updateAudits()">
                  @for (f of Frequencies; track f) {
                    <option [ngValue]="f">{{f.Description}}</option>
                  }
                </select>
              </div>
              <select class="text-box w-full md:max-w-xl lg:mt-3 mt-2 mx-2 standardTextSize"
                [(ngModel)]="SelectedAudit">
                @for (a of DisplayAudits ; track a) {
                  <option [ngValue]="a">{{a.AuditName}}</option>
                }
              </select>
            </div>
          }
        </div>
      }
      @if (showLocationFilter) {
        <div class=" mb-2 border-grey-500 border-[1px] rounded-md p-3">
          <p class="text-lg hover:cursor-pointer" (click)="locationFilterSwitch()">Locations</p>
          @if (!collapseLocationFilter) {
            @if (showQualityManagerFilter || showBusinessDevelopmentManagerFilter) {
              <div class="grid grid-cols-1 gap-3 mt-2 ml-2 lg:grid-cols-2">
                @if (showQualityManagerFilter) {
                  <label>
                    <span class="block mb-1">Regional Quality Assurance Lead</span>
                    <select class="text-box w-full standardTextSize"
                      [ngModel]="SelectedQualityManagerID"
                      (ngModelChange)="onQualityManagerChange($event)">
                      <option [ngValue]="null">All Regional Quality Assurance Leads</option>
                      @for (manager of visibleQualityManagers; track manager.ID) {
                        <option [ngValue]="manager.ID">{{portfolioOptionLabel(manager)}}</option>
                      }
                    </select>
                  </label>
                }
                @if (showBusinessDevelopmentManagerFilter) {
                  <label>
                    <span class="block mb-1">Business Development Manager</span>
                    <select class="text-box w-full standardTextSize"
                      [ngModel]="SelectedBusinessDevelopmentManagerID"
                      (ngModelChange)="onBusinessDevelopmentManagerChange($event)">
                      <option [ngValue]="null">All Business Development Managers</option>
                      @for (manager of visibleBusinessDevelopmentManagers; track manager.ID) {
                        <option [ngValue]="manager.ID">{{portfolioOptionLabel(manager)}}</option>
                      }
                    </select>
                  </label>
                }
              </div>
            }
            <div class="flex flex-col lg:flex-row justify-between ml-2 mt-2">
              <div class="text-box w-full md:max-w-xl mt-2 lg:mt-0">
                <p-select
                  styleClass="w-full prime-input border-0"
                  [options]="useLocationGroups ? LocationGroupsWithAll : Locations"
                  optionLabel="LocationName"
                  optionGroupLabel="label"
                  optionGroupChildren="items"
                  [group]="useLocationGroups"
                  [pt]="{ label: { class: 'block w-full' } }"
                  [filter]="true"
                  filterBy="LocationName"
                  [(ngModel)]="SelectedLocation"
                  (ngModelChange)="onReportingLocationChange()">
                  <ng-template pTemplate="group" let-group>
                    @if (group.label) {
                      <div class="font-semibold text-xs uppercase text-grey-500">
                        {{group.label}}
                      </div>
                    }
                  </ng-template>
                  <ng-template pTemplate="selectedItem" let-loc>
                    <span class="block w-full">{{loc?.LocationName}}</span>
                  </ng-template>
                </p-select>
              </div>
              <div class="flex justify-start  items-center mt-4 lg:mt-0 lg:ml-4">
                <p>Include Sublocations:</p><app-toggle-switch [(checked)]="IncludeSubLocations"
              class="ml-2"></app-toggle-switch>
            </div>
          </div>
        }
      </div>
    }
    <div class=" mb-2 border-grey-500 border-[1px] rounded-md p-3">
      <p class="text-lg hover:cursor-pointer" (click)="optionsFilterSwitch()">Options</p>
      @if (!collapseOptionsFilter) {
        <div>
          <div class="flex mt-2">
            <label class="mr-2">
              <p>Start Date:</p>
              <p-datepicker class="date-input mx-2" inputStyleClass="text-box" [(ngModel)]="StartDate"
                (ngModelChange)="removeStartDateTimeZone($event)" dateFormat="dd M yy" [showIcon]="false"></p-datepicker>
              </label>
              <label class="mr-4">
                <p>End Date:</p>
                <p-datepicker class="date-input mx-2" inputStyleClass="text-box" [(ngModel)]="EndDate"
                  (ngModelChange)="removeEndDateTimeZone($event)" dateFormat="dd M yy" [showIcon]="false"></p-datepicker>
                </label>
              </div>
              <div class="flex-col justify-between w-full px-2 lg:w-[50%]">
                <select class="text-box w-full md:max-w-xl mt-2 standardTextSize" [(ngModel)]="SelectedReport"
                  (change)="updateReportControls()">
                  @for (r of Reports; track r) {
                    <option [ngValue]="r">{{r.ReportName}}</option>
                  }
                </select>
              </div>
              <div class="mt-3 mx-3 text-sm text-grey-900">
                <p>{{SelectedReport.ReportSummary}}</p>
              </div>
            </div>
          }
        </div>
        <div class="flex flex-col lg:flex-row lg:justify-between">
          <button (click)="getReport()" [disabled]="FetchingReport" class="btn-primary mt-3">
            @if (FetchingReport) {
              <span>Loading...</span>
            }
            @if (!FetchingReport) {
              <span>Load Report</span>
            }
          </button>
          @if (SelectedReport.ID != -1 && reportLoaded) {
            <div>
              <a class="hover:cursor-pointer underline hover:text-green-700 mr-4" (click)="switchAllDetails()">
                @if (!showFullDetailsSection) {
                  <span class=" text-sm">View all details</span>
                }
                @if (showFullDetailsSection) {
                  <span class=" text-sm">Show summary</span>
                }</a>
                <button (click)="exportSelectedReport()" [disabled]="FetchingExport" class="btn-inverse mt-3">
                  @if (FetchingExport) {
                    <span>Loading...</span>
                  }
                  @if (!FetchingExport) {
                    <span>Export</span>
                  }
                </button>
              </div>
            }
          </div>
        </div>
      }
      <div class="all-reports p-2 px-4" [ngClass]="{'lg:p-4 mt-6':showFilters}">
        @if (!showFilters) {
          <div class="flex justify-between gap-3 pb-4">
            <button (click)="returnToSummary()" class="btn-inverse mt-4">Return to Summary</button>
            <button (click)="exportSelectedReport()" class="btn-inverse mt-4">Export</button>
          </div>
        }
        @if (showMonthlyAuditCompletionOverview()) {
          <div class="bg-standardwhite border border-grey-300 rounded-md p-4 mb-4">
            <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-2">
              <div>
                <h3>{{ 'audit' | customerTerm:true }} completed by month</h3>
              </div>
              
            </div>
            <div class="mt-4 hidden md:block report-chart">
              <p-chart type="bar" [data]="monthlyAuditCompletionChartData" [options]="monthlyAuditCompletionChartOptions"></p-chart>
            </div>
            <div class="mt-6">
              <table class="w-full table-auto bg-standardwhite border border-grey-300">
                <thead>
                  <tr class="border-b border-grey-300">
                    <th class="text-left p-2">Month</th>
                    <th class="text-right p-2">{{ 'audit' | customerTerm:true }} completed</th>
                  </tr>
                </thead>
                <tbody>
                  @for (r of monthlyAuditCompletionRows; track r.month) {
                    <tr class="border-b border-grey-200">
                      <td class="p-2">{{r.month}}</td>
                      <td class="p-2 text-right">{{formatOverviewCount(r.total)}}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        }
        @if (showMonthlyActionsOverview()) {
          <div class="bg-standardwhite border border-grey-300 rounded-md p-4 mb-4">
            <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-2">
              <div>
                <h3>Actions by month</h3>
              </div>
              
            </div>
            <div class="mt-4 hidden md:block report-chart">
              <p-chart type="line" [data]="monthlyActionsChartData" [options]="monthlyActionsChartOptions"></p-chart>
            </div>
            <div class="mt-6">
              <table class="w-full table-auto bg-standardwhite border border-grey-300">
                <thead>
                  <tr class="border-b border-grey-300">
                    <th class="text-left p-2">Month</th>
                    <th class="text-right p-2">Actions raised</th>
                    <th class="text-right p-2">Actions completed</th>
                    <th class="text-right p-2">Completed on time</th>
                    <th class="text-right p-2">% Completed On Time</th>
                  </tr>
                </thead>
                <tbody>
                  @for (r of monthlyActionsRows; track r.month) {
                    <tr class="border-b border-grey-200">
                      <td class="p-2">{{r.month}}</td>
                      <td class="p-2 text-right">{{formatOverviewCount(r.raised)}}</td>
                      <td class="p-2 text-right">{{formatOverviewCountWhenRaised(r.completed, r.raised)}}</td>
                      <td class="p-2 text-right">{{formatOverviewCountWhenRaised(r.completedOnTime, r.raised)}}</td>
                      <td class="p-2 text-right">{{formatOverviewPercentWhenCompleted(r.completedOnTime, r.completed)}}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        }
        @if (DisplayNonComplianceRows.length>0 && this.SelectedReport.ID == 1 ) {
          <div>
            @if (!showNonComplianceDetails && !showAllNonComplianceDetails) {
              <div>
                <table class="w-full table-auto bg-standardwhite border border-grey-900 report-table">
                  <thead>
                    <tr class="border-b-[1px] border-green-700 ">
                      <th (click)="orderNCByAuditName()" class="text-left  pl-2 py-2 hover:cursor-pointer">{{ 'audit' | customerTerm }}
                      </th>
                      <th (click)="orderNCByQuestion()" class="text-left  p-1 hover:cursor-pointer">Question</th>
                      <th (click)="orderNCByNonCompliance()" class="text-right p-1 hover:cursor-pointer">
                        Non-Compliances
                      </th>
                      <th (click)="orderNCByCompletedAudits()" class="text-right  p-1 hover:cursor-pointer">Total
                        Questions
                      </th>
                      <th (click)="orderNCByPercentage()" class="text-right  p-1 pr-2 hover:cursor-pointer">%</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (r of DisplayNonComplianceRows; track r) {
                      <tr (click)="selectNonComplianceRow(r)"
                        class="border-b-[1px] border-grey-300 hover:bg-grey-100 hover:cursor-pointer">
                        <td class="text-left  p-2">{{r.Info.AuditName}}</td>
                        <td class="text-left  p-2">{{r.Info.QuestionHeader}}</td>
                        <td class="text-right p-2">{{r.NonCompliantCounter}}</td>
                        <td class="text-right p-2">{{r.CompletedQuestionsCounter}}</td>
                        <td class="text-right  p-2">{{r.CompliancePerc}}</td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            }
            @if (showNonComplianceDetails) {
              <div class="">
                <div class="lg:mx-3">
                  <div class="mb-3 mt-5">
                    <h3>{{selectedNonComplianceRow.Info.AuditName}}</h3>
                    <h5>{{selectedNonComplianceRow.Info.QuestionHeader}}</h5>
                  </div>
                  <table class="w-full table-auto bg-standardwhite border border-grey-900 p-2 mt-3 report-table">
                    <thead>
                      <tr class="border-b border-green-700">
                        <th class="text-left p-2">{{ 'audit' | customerTerm }} Date</th>
                        <th class="text-left p-2">Location</th>
                        <th class="text-left p-2">Action Details</th>
                        <th class="text-left p-2">Action Status</th>
                        <th class="text-left p-2">Owner/Closed By</th>
                        <th class="text-right p-2">Due By/Closed On</th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (r of selectedNonComplianceRow.SubNonComplianceRows; track r) {
                        @for (sr of r.Actions; track sr; let first = $first; let last = $last) {
                          <tr
                            class="border-t-[1px] border-grey-300"
                            [ngClass]="{'border-t-2 border-grey-900':first}">
                            @if (first) {
                              <td [attr.rowspan]="r.Actions.length || 1"
                                class="text-left pt-1 pl-1 standardTextSize">
                              {{basicDate(r.Info.DateRecorded)}}</td>
                            }
                            @if (first) {
                              <td [attr.rowspan]="r.Actions.length || 1"
                                class="text-left  pt-1 pl-1 standardTextSize">
                              {{r.Info.LocationName}}</td>
                            }
                            <td class="text-left  pt-1 pl-1 border-l-[1px] border-grey-300 standardTextSize">
                            {{sr.ActionDescription}}</td>
                            <td class="text-left  pt-1 pl-1 standardTextSize">
                              {{noncomplianceStatus(sr.Resolved)}}
                            </td>
                            <td class="text-left  pt-1 pl-1 standardTextSize">
                              {{noncomplianceActionDisplayName(sr)}}
                            </td>
                            <td class="text-right  pt-1 pr-1 standardTextSize">{{noncomplianceActionDate(sr)}}
                            </td>
                          </tr>
                        }
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            }
            @if (showAllNonComplianceDetails) {
              <div class="mt-6">
                <div><h3>Non-compliance - Full Details</h3></div>
                <table class="w-full table-auto bg-standardwhite border border-grey-900 p-2 mt-3 report-table">
                  <thead>
                    <tr class="border-b border-green-700">
                      <th class="text-left p-1">{{ 'audit' | customerTerm }}</th>
                      <th class="text-left p-1">Question</th>
                      <th class="text-left p-1">{{ 'audit' | customerTerm }} Date</th>
                      <th class="text-left p-1">Location</th>
                      <th class="text-left p-1">Action Details</th>
                      <th class="text-left p-1">Action Status</th>
                      <th class="text-left p-1">Owner/Closed By</th>
                      <th class="text-right p-1">Due By/Closed On</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (mr of DisplayNonComplianceRows; track mr) {
                      @for (r of mr.SubNonComplianceRows; track r) {
                        @for (sr of r.Actions; track sr; let first = $first; let last = $last) {
                          <tr
                            class="border-t-[1px] border-grey-300"
                            [ngClass]="{'border-t-2 border-grey-900':first}">
                            @if (first) {
                              <td [attr.rowspan]="r.Actions.length || 1" class="text-left  p-1">
                              {{mr.Info.AuditName}}</td>
                            }
                            @if (first) {
                              <td [attr.rowspan]="r.Actions.length || 1" class="text-left  p-1">
                              {{mr.Info.QuestionHeader}}</td>
                            }
                            @if (first) {
                              <td [attr.rowspan]="r.Actions.length || 1"
                                class="text-left pt-1 pl-1 standardTextSize">
                              {{basicDate(r.Info.DateRecorded)}}</td>
                            }
                            @if (first) {
                              <td [attr.rowspan]="r.Actions.length || 1"
                                class="text-left  pt-1 pl-1 standardTextSize">
                              {{r.Info.LocationName}}</td>
                            }
                            <td class="text-left  pt-1 pl-1 border-l-[1px] border-grey-300 standardTextSize">
                            {{sr.ActionDescription}}</td>
                            <td class="text-left  pt-1 pl-1 standardTextSize">
                              {{noncomplianceStatus(sr.Resolved)}}
                            </td>
                            <td class="text-left  pt-1 pl-1 standardTextSize">
                              {{noncomplianceActionDisplayName(sr)}}
                            </td>
                            <td class="text-right  pt-1 pr-1 standardTextSize">{{noncomplianceActionDate(sr)}}
                            </td>
                          </tr>
                        }
                      }
                    }
                  </tbody>
                </table>
              </div>
            }
          </div>
        }
        @if (DisplayAuditCompletionRows.length>0 && isAuditCompletionReport() ) {
          <div>
            @if (!showAuditCompletionDetails && !showAllAuditCompletionDetails) {
              <div>
                <table class="w-full table-auto bg-standardwhite border border-grey-900 report-table">
                  <thead>
                    <tr class="border-b-[1px] border-green-700 ">
                      <th class="text-left p-2 hover:cursor-pointer" (click)="orderAuditCompletionByAuditName()">
                        {{ 'audit' | customerTerm }}
                      Name</th>
                      <th class="text-left p-2 hover:cursor-pointer" (click)="orderAuditCompletionByFrequency()">
                      Frequency</th>
                      <th class="text-right p-2 hover:cursor-pointer"
                        (click)="orderAuditCompletionByCompletedAudits()">Completed {{ 'audit' | customerTerm:true }}
                      </th>
                      <th class="text-right p-2 hover:cursor-pointer"
                        (click)="orderAuditCompletionByExpectedAudits()">Expected {{ 'audit' | customerTerm:true }}
                      </th>
                      <th class="text-right p-2 hover:cursor-pointer"
                      (click)="orderAuditCompletionByCompletionPerc()">% On Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (r of DisplayAuditCompletionRows; track r) {
                      <tr (click)="selectActionCompletionRow(r)"
                        class="border-b-[1px] border-grey-300 hover:bg-grey-100 hover:cursor-pointer">
                        <td class="text-left p-2">{{r.Info.AuditName}}</td>
                        <td class="text-left p-2">
                        {{frequencyDisplay(r.Info.FrequencyDescription,r.Info.FrequencyMultiplier)}}</td>
                        <td class="text-right p-2">{{r.completedAudits}}</td>
                        <td class="text-right p-2">{{r.expectedTotalAudits}}</td>
                        <td class="text-right p-2">{{r.percAuditsCompleted}}</td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            }
            @if (showAuditCompletionDetails) {
              <div>
                <div class="lg:mx-3">
                  <div class="flex-col flex lg:flex-row lg:justify-between">
                    <div class="mb-3 mt-5">
                      <h3>{{selectedAuditCompletionRow.Info.AuditName}}</h3>
                      <h5>{{ 'audit' | customerTerm }} Frequency:
                        {{frequencyDisplay(selectedAuditCompletionRow.Info.FrequencyDescription,selectedAuditCompletionRow.Info.FrequencyMultiplier)}}
                      </h5>
                    </div>
                    <div class="flex justify-start my-3 items-center">
                      <strong>Show Missed {{ 'audit' | customerTerm:true }} Only:</strong><app-toggle-switch
                      [(checked)]="showOnlyAuditCompletionIssueRows"
                    (checkedChange)="auditCompletedShowOnlyIssue()" class="ml-2"></app-toggle-switch>
                  </div>
                </div>
                <table class="w-full table-auto bg-standardwhite border border-grey-900 p-2 mt-3 report-table">
                  <thead>
                    <tr class="border-b border-green-700">
                      <th class="text-left p-2">Location</th>
                      <th class="text-left p-2">Period</th>
                      <th class="text-right p-2"># {{ 'audit' | customerTerm:true }}</th>
                      <th class="text-center p-2">Successfully Completed</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (r of selectedAuditCompletionRow.subRows; track r) {
                      @for (sr of auditCompletionDetails(r.Details); track sr; let first = $first; let last = $last) {
                        <tr
                          class="border-t-[1px] border-grey-300"
                          [ngClass]="{'border-t-2 border-grey-900':first}">
                          @if (first) {
                            <td [attr.rowspan]="auditCompletionDetails(r.Details).length || 1"
                              class="text-left pt-1 pl-1 standardTextSize">
                            {{r.Info.LocationName}}</td>
                          }
                          <td class="text-left  pt-1 pl-1 standardTextSize">
                          {{auditPeriod(r.Info.FrequencyID,sr.PeriodStart,sr.PeriodEnd)}}</td>
                          <td class="text-right  pt-1 pl-1 standardTextSize">{{sr.TotalCompleted}}
                          </td>
                          <td class="pt-1 px-1 standardTextSize text-center">@if (sr.CompletedInPeriod) {
                            <span
                              class="material-symbols-outlined text-green-300 cursor-pointer pr-2"
                            >check</span>
                            }@if (!sr.CompletedInPeriod) {
                            <span
                            class="material-symbols-outlined text-danger-base cursor-pointer pr-2">close</span>
                          }
                        </td>
                      </tr>
                    }
                  }
                </tbody>
              </table>
            </div>
          </div>
        }
        @if (showAllAuditCompletionDetails) {
          <div class="mt-6">
            <div class="lg:mx-3">
              <div class="flex flex-col lg:flex-row justify-between">
                <h3>{{ 'audit' | customerTerm }} Completion - Full Details</h3>
                <div class="flex justify-start my-3 lg:my-0 items-center">
                  <strong>Show Missed {{ 'audit' | customerTerm:true }} Only:</strong><app-toggle-switch
                  [(checked)]="showOnlyAuditCompletionIssueRows"
                (checkedChange)="auditCompletedShowOnlyIssue()" class="ml-2"></app-toggle-switch>
              </div>
            </div>
            <table class="w-full table-auto bg-standardwhite border border-grey-900 p-2 mt-3 report-table">
              <thead>
                <tr class="border-b border-green-700">
                  <th class="text-left p-1">{{ 'audit' | customerTerm }} Name</th>
                  <th class="text-left p-1">Frequency</th>
                  <th class="text-left p-1">Location</th>
                  <th class="text-left p-1">Period</th>
                  <th class="text-right p-1"># {{ 'audit' | customerTerm:true }}</th>
                  <th class="text-center p-1">Successfully Completed</th>
                </tr>
              </thead>
              <tbody>
                @for (mr of DisplayAuditCompletionRows; track mr) {
                  @for (r of mr.subRows; track r) {
                    @for (sr of auditCompletionDetails(r.Details); track sr; let first = $first; let last = $last) {
                      <tr
                        class="border-t-[1px] border-grey-300"
                        [ngClass]="{'border-t-2 border-grey-900':first}">
                        @if (first) {
                          <td class="text-left pt-1 pl-1 standardTextSize" [attr.rowspan]="auditCompletionDetails(r.Details).length || 1">{{r.Info.AuditName}}</td>
                        }
                        @if (first) {
                          <td class="text-left pt-1 pl-1 standardTextSize" [attr.rowspan]="auditCompletionDetails(r.Details).length || 1">{{r.Info.FrequencyDescription}}</td>
                        }
                        @if (first) {
                          <td  [attr.rowspan]="auditCompletionDetails(r.Details).length || 1"
                            class="text-left pt-1 pl-1 standardTextSize">
                          {{r.Info.LocationName}}</td>
                        }
                        <td class="text-left  pt-1 pl-1 standardTextSize">
                        {{auditPeriod(r.Info.FrequencyID,sr.PeriodStart,sr.PeriodEnd)}}</td>
                        <td class="text-right  pt-1 pl-1 standardTextSize">{{sr.TotalCompleted}}
                        </td>
                        <td class="pt-1 px-1 standardTextSize text-center">@if (sr.CompletedInPeriod) {
                          <span
                            class="material-symbols-outlined text-green-300 cursor-pointer pr-2"
                          >check</span>
                          }@if (!sr.CompletedInPeriod) {
                          <span
                          class="material-symbols-outlined text-danger-base cursor-pointer pr-2">close</span>
                        }
                      </td>
                    </tr>
                  }
                }
              }
            </tbody>
          </table>
        </div>
      </div>
    }
  </div>
}
@if (_RiskAnalysisRows.length>0 && this.SelectedReport.ID == 3 ) {
  <div class="px-1">
    <table class="w-full table-auto bg-standardwhite border border-grey-900 p-2 mt-3 report-table">
      <thead>
        <tr class="border-b border-green-700">
          <th class="text-left p-2">{{ 'audit' | customerTerm }} Name</th>
          <th class="text-left p-2">Question</th>
          <th class="text-left p-2">Answer</th>
          <th class="text-left p-2">Total</th>
        </tr>
      </thead>
      <tbody>
        @for (r of _RiskAnalysisRows; track r) {
          <tr>
            <td class="p-2">{{r.AuditName}}</td>
            <td class="p-2">{{r.QuestionHeader}}</td>
            <td class="p-2">{{r.AnswerText}}</td>
            <td class="text-left p-2">{{r.RowTotal}}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
}
@if (NoData) {
  <div>
    <h3>No Report Data</h3>
    <p>There was no information available with the selected parameters, try to reduce the number of filters
      applied
    or widen the date range.</p>
  </div>
}
</div>

</div>
